/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiAuthBarberLockoutInfo200, GetApiAuthBarberLockoutInfoQueryResponse } from "../entities/GetApiAuthBarberLockoutInfo";
import { modelsLockoutInfoSchema } from "./models/lockoutInfoSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const getApiAuthBarberLockoutInfo200Schema = z.lazy(() => modelsLockoutInfoSchema) as unknown as z.ZodType<GetApiAuthBarberLockoutInfo200>

export const getApiAuthBarberLockoutInfoQueryResponseSchema = z.lazy(() => getApiAuthBarberLockoutInfo200Schema) as unknown as z.ZodType<GetApiAuthBarberLockoutInfoQueryResponse>